(() => {
  async function loadChart(content) {
    if (content.dataset.loaded === 'true' || content.dataset.loading === 'true') return;
    content.dataset.loading = 'true';
    content.textContent = 'Loading size chart…';
    try {
      const response = await fetch(content.dataset.src, {credentials: 'same-origin'});
      if (!response.ok) throw new Error('Chart unavailable');
      const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
      const chart = documentCopy.querySelector('.page__content');
      if (!chart || !chart.textContent.trim()) throw new Error('Empty chart');
      chart.querySelectorAll('script,iframe,object,embed,form,style,link').forEach((node) => node.remove());
      chart.querySelectorAll('*').forEach((node) => {
        [...node.attributes].forEach((attribute) => {
          if (/^on/i.test(attribute.name) || attribute.name === 'srcdoc' || /^(href|src)$/i.test(attribute.name) && /^\s*javascript:/i.test(attribute.value)) node.removeAttribute(attribute.name);
        });
      });
      content.replaceChildren(...chart.childNodes);
      content.dataset.loaded = 'true';
    } catch (_) {
      content.textContent = 'Could not load the size chart. ';
      const link = document.createElement('a');
      link.href = content.dataset.src;
      link.textContent = 'Open size chart page';
      content.append(link);
    } finally { delete content.dataset.loading; }
  }
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-mf-chart-open]');
    if (open) {
      const dialog = open.closest('[data-mf-product]')?.querySelector('[data-mf-chart-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      dialog.showModal();
      loadChart(dialog.querySelector('[data-mf-chart-content]'));
      return;
    }
    const close = event.target.closest('[data-mf-chart-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('[data-mf-chart-dialog]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
})();
